import { parse } from "cookie-es";

import type { LeagueSummary, Schemas } from "@softmax/observatory-client/types";
import {
  resolveWatchLeague,
  watchAddresses,
} from "@softmax/web-features/leagues";

import { navigationLeagues } from "@softmax/web-features/site/catalog";

import { watchLeagueCookie } from "@/lib/leagues/watch-types";

type WatchAddress = {
  slug?: string | null;
  leagueId?: string | null;
  stored?: string | null;
  corpus?: LeagueSummary[] | null;
};

export type WatchSeedAddress = WatchAddress &
  (
    | {
        corpus: LeagueSummary[] | null;
        viewer: Schemas["WhoAmIResponse"] | null;
      }
    | { corpus?: undefined; viewer?: never }
  );

export function storedWatchLeague(): string | null {
  return parse(document.cookie)[watchLeagueCookie] ?? null;
}

export async function watchLeagueFor({
  signal,
  address: input,
}: {
  signal?: AbortSignal | undefined;
  address: WatchAddress;
}): Promise<LeagueSummary | null> {
  const { corpus, stored = storedWatchLeague(), ...address } = input;
  const leagues: LeagueSummary[] | null =
    corpus !== undefined ? corpus : await navigationLeagues({ signal });

  if (!leagues) return null;

  return resolveWatchLeague({
    leagues,
    addresses: watchAddresses(leagues),
    address: {
      ...address,
      stored,
    },
  });
}
